/**
 * DESERTLAND.Content.About
 */
import { Utils } from '../cals.utils';
import { App } from '../desertland.app';
import { ROUTES } from '../desertland.router';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.layout';
// import 'kendo-ui-core/js/kendo.template';

declare var log, info, warn, groupCollapsed, groupEnd;

export class AboutContent {
  public page = ROUTES.ABOUT;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-about';
  public contentSel = '#about-content';
  public biblioSel = "";
  public options: any;
  public biblioReady = false;

  public init(options) {
    groupCollapsed("About.init");
    if (options) {
      log("about.init", options);
      //bibliography
      this.options = options;
    }

    if (App.data.biblio && App.data.biblio.length > 0) {
      info("biblio data ready", App.data.biblio);
      this.biblioReady = true;
    } else {
      info("biblio data not ready yet", App.data.biblio);
      this.biblioReady = false;
      // App.radio.subscribe('dataBiblioReady', this.onBiblioDataReady);
      App.service.load.biblio((data) => {
        //log("biblio loaded, listening to radio... %o", data);
        App.data.biblio = data;
        this.onBiblioDataReady();
        // App.radio('dataBiblioReady').broadcast(data).unsubscribe(DESERTLAND.Content.About.onBiblioDataReady);
      });
    }


    if ($(this.container).length) {
      log("ready for " + this.page);
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        log(this.page + " dom ready!");
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        }

      });
    }
    groupEnd("About.init");
  }

  public onBiblioDataReady() {
    groupCollapsed("About > Biblio > DataReady");
    log("onBiblioDataReady %o", App.data.biblio);
    this.biblioReady = true;
    this.renderBiblio();
    groupEnd("About > Biblio > Render");
  }

public loadTpl (callback) {
  log(this.page + " > loadTpl");
  if ($(this.tplSel).length) {
    log("// we already have the tpl");
    this.renderTpl({ sel: this.tplSel });
  } else {
    App.templates.loadLayout(this.page, this.tplSel, this.renderTpl);
  }

}

public renderTpl = (resp) => {
  $(document).ready(() => {
    groupCollapsed("About > Biblio > Render");
    // me = me || DESERTLAND.Content.About;
    log(this.page + " > renderTpl", resp);
    // log(this.page + " >DEV model:", App.models.pageView);
    if (resp && resp.sel && $(resp.sel).length) {
      //log($(resp.sel));
      let layout = new kendo.Layout($('#'+resp.tag).html(), { model: App.models.pageView.viewModel });
      $(this.container).empty();
      layout.render($(this.container));
  
      this.renderContent();
  
      if (this.options) {
        if ($("#" + this.options + ".anchor").length) {
          window.setTimeout(() => {
            //log("scrollTo",$("#"+this.options).offset().top);
            if ($("#" + this.options).length) {
              Utils.smoothScrollTo('pos', null, $("#" + this.options).offset().top);
            }
            this.options = null;
          }, 200);
        } else {
          Utils.smoothScrollTo('top');
        }
      } else {
        Utils.smoothScrollTo('top');
      }
  
  
    } else {
      info("no sel?");
    }
    groupEnd("About > Biblio > Render");
  });
}

public renderContent (options = {}) {
  log('about > renderContent', options);

  let $container = $(this.contentSel),
    header = App.models.pageView.get('header'),
    headers = (header && header.split('|')) ? header.split('|') : [],
    desc_text = App.models.pageView.get('desc_text'),
    descs = (desc_text && desc_text.split('|')) ? desc_text.split('|') : [];

  log(headers);
  log(descs);

  if ($container.length) {
    $container.hide().empty();
    let len = Math.max(headers.length, descs.length),
      tpl = '<a class="anchor" id="#= headSel #" name="#= headSel #"></a>'
        + '<section class="about-#= headSel # text-center #if(!(index % 2)){#brown-25-bg#}#">'
        + '<div class="container">'
        + '<h3>#= head #</h3>'
        + '<div class="content-desc">'
        + '#= desc #'
        + '</div>'
        + '</div>'
        + '</section>';


    //log('max len = ',len);

    for (let i = 0; i < len; i++) {

      let head = (headers.length > i) ? headers[i] : "",
        headSel = (head) ? Utils.changeSpacesToDashes(head).toLowerCase() : "about-" + i,
        desc = (descs.length > i) ? descs[i] : "",
        data = {
          head,
          headSel,
          desc,
          index: i
        };

      if (headSel.includes('biblio')) {
        this.biblioSel = '.about-' + headSel;
      }
      let template = kendo.template(tpl),
        result = template(data);
      $container.append(result);
    }

    this.renderBiblio();

    $container.fadeIn();
  } else {
    info("$container not found...");
  }



}

public renderBiblio = (data = {}) => {
  log("renderBiblio", data);

  // var me = DESERTLAND.Content.About,
  let $container = $(this.contentSel);

  if (!this.biblioReady || !this.biblioSel || !$container.length || !App.data.biblio || App.data.biblio.length < 1) {
    let s = "biblio not ready yet, waiting for: ";

    if (!this.biblioReady) { info(s + "!biblioReady"); }
    if (!this.biblioSel) { info(s + "!biblioSel"); }
    if (!$container.length) { info(s + "!sel.len"); }
    if (!App.data.biblio) { info(s + "!data.biblio", App.data.biblio); }

  } else {
    info("ok, ready", App.data.biblio);

    let $el = $container.find(this.biblioSel);

    info("biblio here: ", this.biblioSel, $el);

    if ($el.length) {

      /* 
      <div class="container">
      
      <button class="btn btn-collapse action__collapse-biblio" type="button" data-toggle="collapse" data-target="#collapseBiblio" aria-expanded="false" aria-controls="collapseBiblio">
          Full Biblio
      </button>
      <div class="collapse" id="collapseBiblio">
          <div class="biblio-list">Full Biblio (Accordion of Biblios)</div>
      </div>
      </div>
      
      */
      let wrap = $("<div></div>").addClass('biblio-wrap container'),
        btn = $("<button></button>").addClass('btn btn-collapse action__collapse-biblio').attr({
          'type': "button",
          'data-toggle': "collapse",
          'data-target': "#collapseBiblio",
          'aria-expanded': "false",
          'aria-controls': "collapseBiblio"
        }).text("Full Biblio").appendTo(wrap),

        collapseEl = $("<div></div>").attr({ id: 'collapseBiblio' }).addClass('collapse').appendTo(wrap),
        listEl = $("<div></div>").addClass('biblio-list').appendTo(collapseEl);

      // author
      // date
      // description
      // image
      // location
      // nid
      // title

      let itemTpl = '<div class="biblio-item clearfix" data-nid="#= nid #">'
        + '<div class="image" style="background-image:url(\'#= Config.img_url.resource ##= image #\');"></div>'
        + '<h3 class="title">#= title #</h3>'
        + '<h4 class="author">#= author #</h4>'
        + '<div class="description">#= description #</div>'
        + '<div class="date">#= date #</div>'
        + '<div class="location">#= location #</div>'
        + '</div>';



      for (let i = 0; i < App.data.biblio.length; i++) {
        let templateData = App.data.biblio[i];
        templateData.Config = App.config;
        let template = kendo.template(itemTpl),
          result = template(templateData);
        listEl.append(result);
      }

      $el.append(wrap);

    } else {
      info("no biblioSel $el");
    }



  }


}
    
    
    
}
